<template>
  <div v-if="isLoading">
    <div class="header">
      <div class="back-button" @click="goBack">
          <i class="fas fa-chevron-left"></i>
      </div>
      <!-- <img src="https://placehold.co/24x24/333333/FFFFFF?text=V" alt="Valorant logo" class="logo"> -->
      <div class="title">{{ game.name }}</div>
      <!-- <div class="star-button">
          <i class="far fa-star"></i>
      </div> -->
    </div>
    <div class="match-info" v-if="game.participants">
        <div class="team">
            <div class="team-logo">
                <img :src="homeLogo" :alt="homeName + ' logo'" style="width: 60px; height: 60px;">
            </div>
            <div class="team-name">{{ homeName }}</div>
        </div>
        <div class="match-time">
            <div class="time">{{ game.start_time | formatDate1('HH:mm') }}</div>
            <div class="date">{{ game.start_time | formatDate1('MM-DD') }}</div>
        </div>
        <div class="team">
            <div class="team-logo">
                <img :src="awayLogo" :alt="awayName + ' logo'" style="width: 60px; height: 60px;">
            </div>
            <div class="team-name">{{ awayName }}</div>
        </div>
    </div>

    <div class="tabs">
        <div class="tab" >All</div>
        <div class="tab" v-for="type in betType" :key="type.id">{{ type.name }}⚡</div>
    </div>
    <div v-for="type in filteredBettingTypes" :key="game.id + type" class="betting-section">
      <div class="betting-header">
        <div class="betting-title">
          <div class="betting-star">
            <i class="far fa-star"></i>
          </div>
          <div class="betting-name">{{ type.name }}, {{ type.event_part_name }}</div>
        </div>
        <div class="chevron">
          <i class="fas fa-chevron-up"></i>
        </div>
      </div>
      <div class="betting-options" 
      v-for="market in filteredMarkets(type.id, type.event_part_id)" :key="market.id"
      :class="{ 'wrap': filteredMarkets(type.id, type.event_part_id).some(m => getOutcomesByMarket(m.id).length > 2) }"
      >
        <div
          class="betting-option"
          v-for="outcome in getOutcomesByMarket(market.id)"
          :class="{ 'wrap': filteredMarkets(type.id, type.event_part_id).some(m => getOutcomesByMarket(m.id).length > 2) }"
          :key="outcome.id"
        >
          <template v-if="market.is_closed === 0">
            <div class="bet-box">
              <div class="team-label">{{ outcome.name }}</div>
              <div class="odds">{{ outcome.betting_offer_odds }}</div>
              <span v-if="outcome.prev_odds !== undefined">
                <span v-if="outcome.betting_offer_odds > outcome.prev_odds" style="color:#4CAF50;">▲</span>
                <span v-else-if="outcome.betting_offer_odds < outcome.prev_odds" style="color:#f44336;">▼</span>
              </span>
            </div>
          </template>
          <template v-else>
            <div class="bet-box">
              <div class="team-label">{{ outcome.name }}</div>
              <div class="locked-market">
                <i class="fas fa-lock" style="font-size: 24px; color: #aaa;"></i>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>

  </div>
  <div style="text-align: center;" v-else>
    <Loading />
  </div>
</template>

<script>
import Loading from '@/components/Loading.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'GameDetail',
  components: {
    Loading
  },
  props: {
    teams: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      isLoading: false,
      isRequested: false, // 중복 요청 방지용
      betType: [
        { name: '1x2', id: 1 },
        { name: 'Handicap', id: 2 },
        { name: 'Over/Under', id: 3 },
        { name: '1x2', id: 4 },
        { name: 'Handicap', id: 5 },
        { name: 'Over/Under', id: 6 },
      ],
    };
  },
  computed: {
    ...mapGetters('oddsmatrix', [
      'getEvent',
      'getGameDetail',
      'getMarkets',
      'getOutcomes',
      'getMarketOutcomeRelations',
      'getBettingTypes'
    ]),
    selectedGameId() {
      return this.$route.query.gameId || null;
    },
    game() {
      return this.getEvent || {};
    },
    homeName() {
      let name = this.game.name.split(' vs ')[0];
      if (this.game.participants?.find(p => p.participant_role_name === 'Home')) {
        name = this.game.participants?.find(p => p.participant_role_name === 'Home')?.participant_name;
      }
      return name;
    },
    awayName() {
      let name = this.game.name.split(' vs ')[1];
      if (this.game.participants?.find(p => p.participant_role_name === 'Away')) {
        name = this.game.participants?.find(p => p.participant_role_name === 'Away')?.participant_name;
      }
      return name;
    },
    homeLogo() {
      let logo = 'https://static-sdsoft.s3.ap-northeast-1.amazonaws.com/shiled.png';
      if (this.game.participants?.find(p => p.participant_role_name === 'Home')) {
        logo = this.game.participants?.find(p => p.participant_role_name === 'Home')?.participant_logo_url;
      }
      return logo;
    },
    awayLogo() {
      let logo = 'https://static-sdsoft.s3.ap-northeast-1.amazonaws.com/shiled.png';
      if (this.game.participants?.find(p => p.participant_role_name === 'Away')) {
        logo = this.game.participants?.find(p => p.participant_role_name === 'Away')?.participant_logo_url;
      }
      return logo;
    },
    markets() {
      return this.getMarkets || [];
    },
    outcomes() {
      return this.getOutcomes || [];
    },
    marketOutcomeRelation() {
      return this.getMarketOutcomeRelations || [];
    },
    bettingTypes() {
      return this.getBettingTypes || [];
    },
    detailVisible() {
      return this.isDetailVisible;
    },
    // outcomes가 하나라도 있는 bettingType만 반환
    filteredBettingTypes() {
      return this.bettingTypes.filter(type => {
        // 해당 bettingType의 마켓들
        const markets = (this.markets || []).filter(m => m.betting_type === type.id && m.event_part_id === type.event_part_id);
        // 각 마켓별 outcomes가 하나라도 있으면 true
        return markets.some(market => this.getOutcomesByMarket(market.id).length > 0);
      });
    },
    filteredMarkets() {
      return (type, event_part_id) => {
        // outcomes가 하나라도 있는 마켓만 반환
        const markets = this.markets.filter(rel => rel.event_id === this.game.id && rel.betting_type === type  && rel.event_part_id === event_part_id);
        return markets.filter(market => this.getOutcomesByMarket(market.id).length > 0);
      }
    },
  },
  methods: {
    ...mapActions('oddsmatrix', ['fetchGameDetail']),
    loadDetail() {
      if (!this.selectedGameId) return;
      this.isLoading = false;
      this.fetchGameDetail({ event_id: this.selectedGameId });
      this.isLoading = true;
    },
    getOutcomesByMarket(marketId) {
      // 1. 해당 마켓에 연결된 outcome_id 목록 추출
      const marketOutcomeRelations = this.marketOutcomeRelation || [];
      const relations = marketOutcomeRelations.filter(rel => rel.market_id === marketId);
      const outcomeIds = relations.map(rel => rel.outcome_id);
      // 2. outcomes에서 outcome_id가 일치하는 것만 추출
      return (this.outcomes || []).filter(outcome => outcomeIds.includes(outcome.id));
    },
    goBack() {
      this.$router.back();
    }
  },
  mounted() {
    setTimeout(() => {
      this.loadDetail();
    }, 2500);
  }
}
</script>

<style scoped>
.header {
    display: flex;
    align-items: center;
    background-color: #a97bf5;
    padding: 15px;
    position: relative;
}

.back-button {
    color: white;
    font-size: 24px;
    margin-right: 15px;
}

.logo {
    width: 24px;
    height: 24px;
    margin-right: 10px;
}

.title {
    font-size: 16px;
    font-weight: bold;
}

.star-button {
    position: absolute;
    right: 15px;
    color: white;
    font-size: 24px;
}

.match-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #c2a2f6;
    padding: 20px;
}

.team {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 33%;
}

.team-logo {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #333;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.team-name {
    font-size: 14px;
    text-align: center;
}

.match-time {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 33%;
}

.time {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 10px;
}

.date {
    font-size: 14px;
}

.tabs {
    display: flex;
    background-color: #1a1a1a;
    border-bottom: 1px solid #333;
}

.tab {
    padding: 15px 20px;
    font-size: 14px;
    cursor: pointer;
}

.tab.active {
    color: #c2a2f6;
    border-bottom: 2px solid #c2a2f6;
}

.betting-section {
    margin-top: 10px;
    background-color: #222;
    margin-bottom: 10px;
}

.betting-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: #2a2a2a;
}

.betting-title {
    display: flex;
    align-items: center;
}

.betting-star {
    margin-right: 10px;
    color: white;
    font-size: 18px;
}

.betting-name {
    font-size: 14px;
}

.chevron {
    color: white;
    font-size: 18px;
}

.betting-options {
    display: flex;
    padding: 10px;
}

.betting-options.wrap {
  flex-direction: row;
  overflow-x: auto;
  white-space: nowrap;
  gap: 8px;
  padding-bottom: 4px;
}

/* .betting-option.wrap {
  flex: 0 0 auto;
} */

.betting-option {
    flex: 1;
    padding: 10px;
}

.team-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 15px;
}

.team-column {
    width: 50%;
    font-size: 14px;
}

.bet-box {
    background-color: #333;
    padding: 15px;
    margin: 5px;
    border-radius: 5px;
}

.team-label {
    font-size: 14px;
    margin-bottom: 5px;
}

.odds {
    font-size: 16px;
    color: #a095c7;
}

.handicap-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px;
}

.handicap-row {
    display: flex;
    width: 100%;
}

.handicap-box {
    flex: 1;
    background-color: #333;
    padding: 15px;
    border-radius: 5px;
    margin: 5px;
}

.handicap-value {
    font-size: 14px;
    margin-bottom: 5px;
}

.three-column-grid {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;
    padding: 10px;
}

.map-score-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px;
}

.map-score-row {
    display: flex;
    width: 100%;
}

.draw-column {
    text-align: center;
}

.draw-odds {
    color: #a095c7;
}

/* 새로운 애니메이션 스타일 */
.bet-box, .handicap-box {
    transition: all 0.3s ease;
    cursor: pointer;
}

.bet-box:hover, .handicap-box:hover {
    transform: scale(1.05);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.2);
    background-color: #444;
}

.tab {
    transition: all 0.3s ease;
}

.tab:hover {
    background-color: #333;
}

.betting-header {
    transition: all 0.3s ease;
    cursor: pointer;
}

.betting-header:hover {
    background-color: #3a3a3a;
}

.back-button, .star-button {
    transition: all 0.3s ease;
    cursor: pointer;
}

.back-button:hover, .star-button:hover {
    transform: scale(1.1);
    color: #3a3a3a;
}

@keyframes pulse {
    0% {
        transform: scale(1);
    }
    50% {
        transform: scale(1.05);
    }
    100% {
        transform: scale(1);
    }
}

.odds {
    transition: all 0.3s ease;
}

/* .bet-box:hover .odds, .handicap-box:hover .odds {
    color: #ff6b4a;
    animation: pulse 1s infinite;
} */

.locked-market {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  font-size: 24px;
  min-height: 48px;
}
</style> 